<script setup>
const props = defineProps({ blok: Object })

const classes = computed(() => {
  switch (props.blok?.style) {
    case 'custom':
      return `w-[${props.blok?.style}%]`
    case '75%':
      return 'w-3/4'
    case '50%':
      return 'w-1/2'
    case '33%':
      return 'w-1/3'
    case 'auto':
      return 'w-auto'
    default :
      return 'w-full'
  }
})
</script>
<template>
  <nuxt-img
    :class="classes"
    class="my-custom-md mx-auto"
    v-bind="$attrs"
    provider="storyblok"
    format="webp"
    object-fit="fill"
    sizes="sm:100vw md:655px lg:1100px"
  />
</template>